import { Placeholder } from "./Placeholder.js";

export default Placeholder;
